























































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

import { GET_ISSUES } from '@/system/store/getter-types'
import { STORE_TZ } from '@/system/store/action-types'
import { IActionType } from '@/system/store'
import { matchFieldsLocalisationKeys } from '@/features/matchFields/matchFields.localisation'
import * as moment from 'moment-timezone'

interface IOption {
  label: string
  value: string
}
@Component
export default class ChooseTzDialog extends Vue {
  private translations = matchFieldsLocalisationKeys
  private showDialog: boolean = false
  private selectedTZ: IOption = {} as IOption
  private timeZones: any[] = []
  private currentTz: IOption = {} as IOption
  private prevTz: string = ''

  @Action(STORE_TZ)
  storeTz!: IActionType

  private created (): void {
    this.timeZones = moment.tz.names().map((tz: string) => {
      const tzOffsetInHours = moment.tz(tz).utcOffset() / 60
      return {
        label: `${tz} (${tzOffsetInHours > 0 ? 'GMT +' : 'GMT '}${tzOffsetInHours})`,
        value: tz
      }
    })
    const currentTz = moment.tz.guess()
    const currentTzOffset = moment.tz(currentTz).utcOffset() / 60
    this.currentTz = {
      value: currentTz,
      label: `${currentTz} (${currentTzOffset > 0 ? 'GMT +' : 'GMT '}${currentTzOffset})`
    }
    this.selectedTZ = this.currentTz
  }

  private handleShowDialog (): void {
    this.showDialog = !this.showDialog
  }

  public openDialog () {
    this.showDialog = true
  }

  private handleSave () {
    this.storeTz(this.selectedTZ.value)
  }

  private selectCurrent (): void {
    const currentTz = this.currentTz.value
    this.selectedTZ = this.timeZones.reduce((acc: IOption, tz: IOption) => {
      if (tz.value === currentTz) acc = tz
      return acc
    }, {})
    this.storeTz(currentTz)
  }

  private clear (): void {
    this.setDefaultAndClose()
  }

  private cancel (): void {
    this.setDefaultAndClose(this.prevTz)
  }

  private setDefaultAndClose (tz: string = ''): void {
    this.selectedTZ = this.currentTz
    this.storeTz(tz)
    this.handleShowDialog()
  }

  private filterFn (filter: string, update: Function, abort: Function) {
    update(() => {
      const needle: string = filter.toLowerCase()
      this.timeZones = this.timeZones.filter(({ value }: { value: string }) => value.toLowerCase().includes(needle))
    })
  }
}
